@if (asHeading()) {
  <h1 class="s__overline">{{ text() }}</h1>
} @else {
  <span class="s__overline">{{ text() }}</span>
}
